module.exports = __webpack_public_path__ + "media/images/logo-1ee10c5b197fb576cb450de75c4da7ad.png";